<template>
  <div class="verification">
    <div :class="verificationImage"></div>
    <h3 class="verification__title">{{ title }}</h3>
    <p class="verification__description">{{ description }}</p>
    <button class="verification__button sk-btn sk-btn--default"
            @click="verify">{{ actionButtonText }}</button>
    <p v-if="isMobileApp"
       class="verification__mobile-warning"
       v-html="mobileAppVersionWarningText"></p>
    <div v-if="userIsInterpreter"
         class="verification__interpreter-text"
         v-html="supporEmailText"></div>
    <accordion v-if="!onboarding"
               class="verification-accordion">
      <div slot="header"
           class="assignment-accordion__header translation-info">
        <p class="verification-accordion__subtitle">{{ verificationAccordionTitle }}</p>
      </div>
      <template slot="content">
        <p v-for="(item, index) in accordionText"
           :key="index"
           class="verification-accordion__main-text">{{ item }}</p>
      </template>
    </accordion>
    <accordion v-if="isMobileApp && !onboarding"
               class="verification-accordion">
      <div slot="header"
           class="assignment-accordion__header translation-info">
        <p class="verification-accordion__subtitle">{{ mobileAppAccordionTitle }}</p>
      </div>
      <template slot="content">
        <p v-for="(item, index) in mobileAppAccordionText"
           :key="index"
           class="verification-accordion__main-text"
           v-html="item">
        </p>
      </template>
    </accordion>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import constants from '@/modules/constants';
  import Accordion from '@/components/shared_components/Accordion';

  export default {
    components: {
      accordion: Accordion,
    },
    props: {
      onboarding: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapGetters('UserInfoStore', ['userIsInterpreter', 'identityVerificationCreated']),
      title() { return this.identityVerificationCreated ? this.$gettext('Sign in with BankID') : this.$gettext('Verify your identity'); },
      isMobileApp() { return this.$store.state.mobileApp; },
      description() {
        if (this.onboarding) return this.$gettext('You need to verify your identity in order to proceed. BankID verification ensures secure access and protects your personal and account information.');
        return this.identityVerificationCreated ? this.$gettext('You need to sign in with your BankID in order to view this page.') : this.$gettext('You need to verify your identity in order to view this page.');
      },
      supporEmailText() {
        const template = this.$gettext('Don\'t have Norwegian BankID? Contact us at: <a class="sk-link sk-link--default" href="mailto:%{support}">%{support}</a>');
        return this.$gettextInterpolate(template, {support: this.$getString('domainData', 'supportEmail')});
      },
      iosApp() { return this.$store.state.mobileApp == 'ios'; },
      iosAppLink() { return constants.IOS_APP_LINK; },
      androidAppLink() { return constants.ANDROID_APP_LINK; },
      mobileAppVersionWarningText() {
        const appLink = this.iosApp ? this.iosAppLink : this.androidAppLink;
        const template = this.$gettext('Please make sure you\'re using the latest version of the app <a class="sk-link sk-link--default" href="%{appLink}">link</a> to avoid issues with verifying your identity.');
        return this.$gettextInterpolate(template, {appLink: appLink});
      },
      contactUsText() { return this.$gettext('Don\'t have Norwegian BankID?'); },
      verificationAccordionTitle() { return this.$gettext('Why this additional login?'); },
      mobileAppAccordionTitle() { return this.$gettext('Having issue passing BankID verification on mobile app?'); },
      actionButtonText() { return this.identityVerificationCreated ? this.$gettext('Sign in') : this.$gettext('Verify via BankID'); },
      verificationImage() {
        if (this.onboarding) return 'supplier-verification__image';
        return this.identityVerificationCreated ? 'verification__image--sign-in' : 'verification__image';
      },
      accordionText() {
        return [
          this.$gettext('Some documents contain sensitive information that requires additional security. Therefore, they are only opened in a protected solution, and we must verify your identity.'),
          this.$gettext('We never ask for more information than necessary, and everything is stored securely in line with national requirements for handling personal information.'),
          this.$gettext('Thank you for contributing to the safe processing of patient data.'),
        ];
      },
      mobileAppAccordionText() {
        return [
          this.$gettext('Please make sure you have the latest version of the app installed.'),
        ];
      },
    },
    methods: {
      verify() { this.$emit('verify'); }
    }
  };
</script>
